import { graphql } from 'babel-plugin-relay/macro';
import { get, includes } from 'lodash';
import { call, takeLatest } from 'redux-saga/effects';
import { fetchQuery } from 'relay-runtime';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import environment from '@lib/utils/RelayEnvironment';

import { ON_SOCKET_TELEHEALTH } from 'containers/App/constants';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

const query = graphql`
  query sagaWatchersTelehealthQuery($id: MongoID!) {
    appointmentById(_id: $id) {
      telehealth {
        patientWaitingSince
        status
        duration
        sessionDetails {
          readiness {
            camera
            microphone
            browser
          }
        }
      }
    }
  }
`;

function* sagaInvalidateStore() {
  yield sagaRelayInvalidateData('Telehealth');
}

function* sagaOnSocketActivity(action: any) {
  const namespace = get(action, 'data.namespace');
  if (get(action, 'data.appointment') && get(action, 'data.sessionDetails')) {
    try {
      yield call(fetchQuery, environment, query, { id: get(action, 'data.appointment') });
    } catch (error) {
      sendLog('sagaWatchersTelehealth#sagaWatcher', { error, action }, LoggerStatusEnum.error);
    }
  } else if (
    get(action, 'data.activityContext') &&
    get(action, 'data.activityContext.appointment') &&
    get(action, 'data.activityContext.sessionDetails')
  ) {
    try {
      yield call(fetchQuery, environment, query, { id: get(action, 'data.activityContext.appointment') });
    } catch (error) {
      sendLog('sagaWatchersTelehealth#sagaWatcher', { error, action }, LoggerStatusEnum.error);
    }
  }

  if (
    includes(['api:telehealths:update'], namespace) ||
    get(action, 'data.sessionDetails') ||
    get(action, 'data.activityContext.sessionDetails')
  ) {
    yield sagaInvalidateStore();
  }
}

export default function* sagaWatchersTelehealth() {
  // Based on socket events
  yield takeLatest(ON_SOCKET_TELEHEALTH, sagaOnSocketActivity);
}
